import { ChangeDetectionStrategy, Component, HostListener, Input } from "@angular/core";
import { PermitPublicStatus } from "@ha/data/basic";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PermitListItem } from "../../models/permit-list-item.model";
import { PermitListType } from "../../models/permit-list-type.enum";
import { PermitListActions } from "../../states/permit-list.actions";
import { PermitListSelectors } from "../../states/permit-list.selectors";

@Component({
    selector: "pmt-permit-list",
    templateUrl: "./permit-list.component.html",
    styleUrls: ["./permit-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitListComponent {
    @Input()
    public listType: PermitListType;

    @Input()
    public permits: PermitListItem[];

    public PublicPermitStatus = PermitPublicStatus;
    public PermitListType = PermitListType;
    public currentSkip = 0;
    public isLoading = false;
    public getAllCompletedAction = PermitListActions.GetAllCompleted;
    public showScrollToTop = false;

    @Select(PermitListSelectors.hasMoreCompletedPermits)
    public hasMoreCompletedPermits$: Observable<boolean>;

    constructor(private store: Store) {}

    @HostListener("window:scroll", [])
    public onWindowScroll(): void {
        this.showScrollToTop = window.scrollY > 300;
    }

    public statusKeys(): string[] {
        const keys = Object.keys(this.PublicPermitStatus);
        return keys.slice(keys.length / 2);
    }

    public statusExists(status: PermitPublicStatus): boolean {
        return this.permits.some((_) => _.publicStatus === status);
    }

    public fetchMoreCompletedPermits(): void {
        if (this.listType !== PermitListType.Completed || this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.currentSkip += 50;

        this.store.dispatch(new PermitListActions.GetAllCompleted(this.currentSkip, 50)).subscribe(() => {
            this.isLoading = false;
        });
    }

    public scrollToTop(): void {
        this.showScrollToTop = false;
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
